import React, { useState, useEffect } from "react" ;
import { Calendar, dateFnsLocalizer } from "react-big-calendar";
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import moment from "moment";
import format from "date-fns/format";
import parse from "date-fns/parse";
import startOfWeek from "date-fns/startOfWeek";
import getDay from "date-fns/getDay";

import { Globals, getDataFromResponse } from "root/DataFunctions/BaseDataFns";
import { getChildDiaryEntries, createChildDiaryEntry } from "root/DataFunctions/ChildDataFns";
import useModalViewChildDiaryEntry from "root/Modals/ViewChildDiaryEntry/useModalViewChildDiaryEntry";
import FormInput from "../Components/UI/FormInput";
import FormTextArea from "../Components/UI/FormTextArea";
import ChildButton from "../Components/UI/ChildButton";
import ChildDatePicker from "../Components/UI/ChildDatePicker";

import closeIcon from "../assets/icons/close.png";

import "react-big-calendar/lib/css/react-big-calendar.css";
import "react-big-calendar/lib/addons/dragAndDrop/styles.css";
import "../styles/Pages/diary.scss";

const locales = {
    "en-GB": require("date-fns/locale/en-US")
}

const localizer = dateFnsLocalizer({
    format, parse, startOfWeek, getDay, locales
})

const navigate = {
    PREVIOUS: 'PREV',
    NEXT: 'NEXT',
    TODAY: 'TODAY',
    DATE: 'DATE'
};

const Diary = () => {
    const [allDiaryEntries, setAllDiaryEntries] = useState("");
    const [diaryDrawer, setDiaryDrawer] = useState(false);
    const [newEvent, setNewEvent] = useState({
        title: "",
        entry: "",
        class: "",
        start: new Date(),
        end: new Date(),
    });

    const [calendarHeight, setCalendarHeight] = useState("");

    const reallySadUrl = Globals.BaseURL + "/images/diary/new/face1.png";
    const sadUrl = Globals.BaseURL + "/images/diary/new/face2.png";
    const confusedUrl = Globals.BaseURL + "/images/diary/new/face6.png";
    const okUrl = Globals.BaseURL + "/images/diary/new/face3.png";
    const happyUrl = Globals.BaseURL + "/images/diary/new/face4.png";
    const reallyHappyUrl = Globals.BaseURL + "/images/diary/new/face5.png";
    const newIconUrl = Globals.BaseURL + "/images/icons/child/add-calendar.png";

    // Modal
    const [ renderModalViewChildDiaryEntry, onActivateModalViewChildDiaryEntry ] = useModalViewChildDiaryEntry();

    const onChange = e => {
        setNewEvent({ ...newEvent, [e.target.name]: e.target.value })
    }

    const EventComponent = (devent) => { 
        const eventClassName = devent.devent.event.class

        let feelingIconName = ""
        if (eventClassName === "event-warning") {
            feelingIconName = "face1"
        } else if (eventClassName === "event-important") {
            feelingIconName = "face2"
        } else if (eventClassName === "event-inverse") {
            feelingIconName = "face3"
        } else if (eventClassName === "event-confused") {
            feelingIconName = "face6"
        } else if (eventClassName === "event-special") {
            feelingIconName = "face4"
        } else if (eventClassName === "event-success") {
            feelingIconName = "face5"
        } else {
            feelingIconName = "face3"
        }
        
        const eventUrl = Globals.BaseURL + "/images/diary/new/" + feelingIconName +".png"
        return ( 
            <span className="diary-emoji"> 
                <img className="diary-emoji-icon" src={eventUrl} alt="face1" /> 
            </span> 
        ) 
    }

    const handleAddEvent = (e) => {
        e.preventDefault();
        setAllDiaryEntries([...allDiaryEntries, newEvent]);

        const dbEntry = { 
            "EventDate": moment(newEvent.start).format('DD-MM-YYYY'),
            "InputText": newEvent.entry,
            "InputTitle": newEvent.title,
            "feelings": newEvent.class,
        }

        createChildDiaryEntry(dbEntry, response =>
        {
            console.log(response)
        });

        setNewEvent({
            ...newEvent,
            title: "",
            entry: "",
            class: "",
            start: new Date(),
            end: new Date()
        });
        setDiaryDrawer(false);
    }

    const onNavigate = (date) => {
        getMaxNumEventInMonth(date);
    }

    const getMaxNumEventInMonth = (date) => {
        const curntMth = moment(date).month();
        const curntYr = moment(date).year();

        let monthEvents = "";
        allDiaryEntries && allDiaryEntries.map((entry) => {
            if(moment(entry.start).month() === curntMth && moment(entry.start).year() === curntYr) {
                console.log(entry);
                // let day = moment(entry.start).day();

                var check = moment(entry.start, 'YYYY/MM/DD');
                var day   = check.format('D');

                monthEvents = [...monthEvents, day];
            }
        })

        // Get item that appears the most in an array
        if (monthEvents) {
            const count = monthEvents.reduce((accumulator, value) => {
                return {...accumulator, [value]: (accumulator[value] || 0) + 1};
            }, {});
            
            let arr = Object.values(count);
            let max = Math.max(...arr);

            let heightToAdd = 700; 
            console.log("b4",heightToAdd);
            if (max > 1) {
                for (let i = 1; i <= max; i++) {
                    heightToAdd = heightToAdd + 300;                    
                }
            }
            setCalendarHeight(heightToAdd);
            setTimeout(() => setCalendarHeight("auto"), 500);

        }
    }
    
    function debounce(fn, ms) {
        let timer;
        return _ => {
          clearTimeout(timer)
          timer = setTimeout(_ => {
            timer = null
            fn.apply(this, arguments)
          }, ms)
        };
    }   

    useEffect(() => {
        getChildDiaryEntries(response =>
        {
            const arrEntries = getDataFromResponse(response)
            const diaryEntries = arrEntries.map((entry) => {
                return {
                    ...entry,
                    end: new Date(parseInt(entry.start)),
                    start: new Date(parseInt(entry.end)),
                }
            })
            setAllDiaryEntries(diaryEntries);  
        });

    }, []);

    useEffect(() => {
        setCalendarHeight(1626);
        setTimeout(() => setCalendarHeight("auto"), 500);

        const debouncedHandleResize = debounce(function handleResize() {
            // const tempDate = new Date();
            // getMaxNumEventInMonth(tempDate);
            setCalendarHeight(1626);
            setTimeout(() => setCalendarHeight("auto"), 500);
        }, 50)

        window.addEventListener('resize', debouncedHandleResize)
        
        return _ => {
            window.removeEventListener('resize', debouncedHandleResize)
        }

    }, [allDiaryEntries]);
    
    useEffect(() => {
        const keyDownHandler = event => {
            if (event.key === 'Escape') {
                setDiaryDrawer(false);
            }
        };
        document.addEventListener('keydown', keyDownHandler);
        return () => document.removeEventListener('keydown', keyDownHandler);
    }, []);

    return (
        <>
            {renderModalViewChildDiaryEntry()}

            <div className="child_breadcrumb">
                <div className="child_breadcrumb_inner">
                    <h2 className="child_breadcrumb_title">Diary</h2>
                </div>
            </div>
            <div className={diaryDrawer ? "child-diary active" : "child-diary"}>
                <div className="child-diary-inner">
                    <div className="child-diary-inner-add">
                        <button
                            onClick={() => setDiaryDrawer(true)}
                            className="child_button_icon"
                        >
                            <img className="icn" src={newIconUrl} alt="Add new entry" />
                        </button>
                    </div>

                    {/* <div style={{
                        position: "absolute",
                        left: "0",
                        height: "6rem",
                        width: "100%",
                    }}>wersfsdf</div> */}

                    {allDiaryEntries && <Calendar
                        components={{ event: (revent) => <EventComponent devent={revent} /> }}
                        localizer={localizer}
                        events={allDiaryEntries}
                        startAccessor="start"
                        endAccessor="end"
                        style={{height: calendarHeight}}
                        // onEventDrop={onEventDrop}
                        // onSelectEvent={event => console.log(event)}
                        // onSelectEvent={event => console.log(event.title, event.entryText)}
                        onNavigate={date => onNavigate(date)}
                        onSelectEvent={event => onActivateModalViewChildDiaryEntry(event)}
                    />}

                    <div className="new-diary-entry">
                        <form onSubmit={handleAddEvent}>
                            <div className="sideDrawer_theme_header">
                                <h2 className="title">New Diary Entry</h2>
                                <div 
                                    onClick={ () => setDiaryDrawer(false) } 
                                    className="close_button"
                                >
                                    <img className="icon" src={closeIcon} alt="Close Icon" />
                                </div>
                            </div>

                            <div className="new-diary-entry-body">
                                <div className="child-diary-emoji-group">
                                    <OverlayTrigger
                                        placement="top"
                                        overlay={ <Tooltip id="tooltip-top"> Excited </Tooltip> }
                                    >
                                        <label>
                                            <input 
                                                required={true}
                                                type="radio"
                                                id="special"
                                                name="class"
                                                value="event-success"
                                                checked={newEvent.class === "event-success"}
                                                onChange={(e) => setNewEvent({...newEvent, class: e.target.value})}
                                            />
                                                <img className="emoji-icon" src={reallyHappyUrl} alt="Really Happy emoji" />
                                            <div className="emoji-blur"></div>
                                        </label>
                                    </OverlayTrigger>

                                    <OverlayTrigger
                                        placement="top"
                                        overlay={ <Tooltip id="tooltip-top"> Happy </Tooltip> }
                                    >
                                        <label>
                                            <input 
                                                type="radio" 
                                                name="class"
                                                value="event-special"
                                                checked={newEvent.class === "event-special"}
                                                onChange={(e) => setNewEvent({...newEvent, class: e.target.value})}
                                            />
                                            <img className="emoji-icon" src={happyUrl} alt="Happy emoji" />
                                            <div className="emoji-blur"></div>
                                        </label>
                                    </OverlayTrigger>

                                    
                                    <OverlayTrigger
                                        placement="top"
                                        overlay={ <Tooltip id="tooltip-top"> Worried </Tooltip> }
                                    >
                                        <label>
                                            <input 
                                                type="radio" 
                                                name="class"
                                                value="event-inverse"
                                                checked={newEvent.class === "event-inverse"}
                                                onChange={(e) => setNewEvent({...newEvent, class: e.target.value})}
                                            />
                                            <img className="emoji-icon" src={okUrl} alt="Ok emoji" />
                                            <div className="emoji-blur"></div>
                                        </label>
                                    </OverlayTrigger>

                                    <OverlayTrigger
                                        placement="top"
                                        overlay={ <Tooltip id="tooltip-top"> Confused </Tooltip> }
                                    >
                                        <label>
                                            <input 
                                                type="radio" 
                                                name="class"
                                                value="event-confused"
                                                checked={newEvent.class === "event-confused"}
                                                onChange={(e) => setNewEvent({...newEvent, class: e.target.value})}
                                            />
                                            <img className="emoji-icon" src={confusedUrl} alt="Confused emoji" />
                                            <div className="emoji-blur"></div>
                                        </label>
                                    </OverlayTrigger>

                                    
                                    <OverlayTrigger
                                        placement="top"
                                        overlay={ <Tooltip id="tooltip-top"> Sad </Tooltip> }
                                    >
                                        <label>
                                            <input 
                                                type="radio" 
                                                name="class"
                                                value="event-important"
                                                checked={newEvent.class === "event-important"}
                                                onChange={(e) => setNewEvent({...newEvent, class: e.target.value})}
                                            />
                                            <img className="emoji-icon" src={sadUrl} alt="Sad emoji" />
                                            <div className="emoji-blur"></div>
                                        </label>
                                    </OverlayTrigger>

                                    <OverlayTrigger
                                        placement="top"
                                        overlay={ <Tooltip id="tooltip-top"> Angry </Tooltip> }
                                    >
                                        <label>
                                            <input 
                                                type="radio" 
                                                name="class"
                                                value="event-warning"
                                                checked={newEvent.class === "event-warning"}
                                                onChange={(e) => setNewEvent({...newEvent, class: e.target.value})}
                                            />
                                            <img className="emoji-icon" src={reallySadUrl} alt="Really Sad emoji" />
                                            <div className="emoji-blur"></div>
                                        </label>
                                    </OverlayTrigger>
                                </div>

                                <ChildDatePicker
                                    dateFormat="dd-MM-yy"
                                    placeholderText="Start Date"
                                    selected={newEvent.start}
                                    showPopperArrow={false}
                                    onKeyDown={(e) => {
                                        e.preventDefault();
                                    }}
                                    onChange={(start) => setNewEvent({ ...newEvent, start, end: start })}
                                    placeholdeInfo="Select a day"
                                />

                                <FormInput
                                    type="text"
                                    placeholder="Add title"
                                    value={newEvent.title}
                                    name="title"
                                    onChange={onChange}
                                />

                                <FormTextArea
                                    // type="text"
                                    placeholder="Add Entry"
                                    value={newEvent.entry}
                                    name="entry"
                                    onChange={onChange}
                                />          
                                
                                <ChildButton
                                    value="Submit"
                                    // onClick={handleAddEvent}
                                />
                            </div>
                        </form>
                    </div>

                </div>
                <div 
                    className="child-diary-backdrop"
                    onClick={ () => setDiaryDrawer(false) } 
                ></div>
            </div>
        </>
    );
}

export default Diary;
